export class UserResponsibleRequest {
  nombre: string;
  apellido: string;
  email: string;
  idsSucursal: number[] | [];
  idResponsable: number;
  isPix: boolean;
  rol: string;

  constructor(
    nombre: string,
    apellido: string,
    email: string,
    idsSucursal: number[] | [],
    idResponsable?: number,
    rol?: string
  ) {
    this.nombre = nombre;
    this.apellido = apellido;
    this.email = email;
    this.idsSucursal = idsSucursal;
    this.idResponsable = idResponsable;
    this.isPix = true;
    this.rol = rol;
  }
}

export class UserEditResponsibleRequest {
  nombre: string;
  apellido: string;
  email: string;
  idsSucursal: number[] | [];
  idResponsable: number;
  rol: string;

  constructor(nombre, apellido, email, idsSucursal, idResponsable, rol) {
    this.nombre = nombre;
    this.apellido = apellido;
    this.email = email;
    this.idsSucursal = idsSucursal;
    this.idResponsable = idResponsable;
    this.rol = rol;
  }
}
